import { createSignal } from "solid-js"
import type { ServerConnection } from "@/context/server"
import { authTokenFromCredentials } from "@/utils/server"
import type { Expert } from "./expert-types"

const [expertListRevision, setExpertListRevision] = createSignal(0)

export async function expertApiFetch<T>(
  getServer: () => ServerConnection.Any | undefined,
  path: string,
  options?: RequestInit,
): Promise<T> {
  const server = getServer()?.http
  if (!server?.url) throw new Error("未选择服务器，请在设置中选择 opencode 后端地址")

  const headers: Record<string, string> = {
    ...((options?.headers as Record<string, string>) ?? {}),
  }
  if (server.password) {
    headers.Authorization = `Basic ${authTokenFromCredentials({
      username: server.username,
      password: server.password,
    })}`
  }

  const response = await fetch(`${server.url.replace(/\/+$/, "")}/api/expert${path}`, { ...options, headers })
  if (!response.ok) throw new Error(`API error: ${response.status} ${response.statusText}`)
  if (response.status === 204) return undefined as T
  return response.json()
}

export function fetchExperts(getServer: () => ServerConnection.Any | undefined) {
  return expertApiFetch<Expert[]>(getServer, "")
}

export function invalidateExperts() {
  setExpertListRevision((revision) => revision + 1)
}

export { expertListRevision }
